import styled from 'styled-components';
import { FlexBox, StackPanel, TabsPanel, Typography } from '@agilepoint/wat-react-ux';
import { NegativeActionButton } from 'common';

export const ContentWrapper = styled(StackPanel)`
    background: ${({ theme: { mobileAppAccelerator } }) => mobileAppAccelerator.semanticColors.grayVariant6};
    padding: 25px 0px 0px 30px;
    border-radius: 8px;
    box-sizing: border-box;
`;

export const LogoTileWrapper = styled(StackPanel)`
    background: ${({ theme: { semantics } }) => semantics.palette.white};
    width: 150px;
    height: 150px;
    padding: 20px;
    box-sizing: border-box;
    border: 1px solid ${({ theme: { mobileAppAccelerator: { semanticColors } } }) => semanticColors.grayVariant5};
    border-radius: 16px;
`;

export const StyledImage = styled.img`
    min-width: 50px;
    max-width: 80px;
    max-height: 60px;
`;

export const StyledTabsPanel = styled(TabsPanel)`
    height: 100%;
    width: 100%;
    position: relative;
    box-sizing: border-box;

    .ap-tabsPanel-tabHeaderContainer {
        height: 30px;
    }

    .ap-tabsPanel-tabContentContainer {
        height: calc(100% - 50px) !important;
        margin: 20px 0px 0px 0px !important;
        overflow-y: auto !important;
        border: none;
    }
    .ap-tabsPanel-tabItemWrapper {
        z-index: 1;
    }

    .ap-tabsPanel-tabItemWrapper:first-child {
        border-radius: 6px 0px 0px 6px;
    }
    .ap-tabsPanel-tabItemWrapper:last-child {
        border-radius: 0px 6px 6px 0px;
    }
    .ap-tabsPanel-tabItemWrapper:only-child {
        border-radius: 6px;
    }

`;

export const AndroidDescription = styled(Typography.Medium)`
    margin-top: 10px;
    box-sizing: border-box;
    display: block;
    text-align: center;
    max-width: 612px;
    line-height: 24px;
`;

export const RelativePositionedFlexBox = styled(FlexBox)`
    position: relative;
    max-width: 1060px;
    margin-top: 30px
`;

export const ResetButton = styled(NegativeActionButton)`
    position: absolute;
    right: 0px;
    z-index: 5;
`;
